import { render, staticRenderFns } from "./automation-canvas.vue?vue&type=template&id=318253c0&scoped=true"
import script from "./automation-canvas.vue?vue&type=script&lang=js"
export * from "./automation-canvas.vue?vue&type=script&lang=js"
import style0 from "./automation-canvas.vue?vue&type=style&index=0&id=318253c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318253c0",
  null
  
)

export default component.exports